import Ztext from "react-ztext";
import "./WelcomeBanner.css";
const WelcomeBanner = () => {
  return (
    <>
      <div className="WelcomeBanner-wrapper">
        <span className="welcome-banner-big">
          <Ztext
            depth="1rem"
            direction="both"
            event="pointer"
            eventRotation="40deg"
            eventDirection="default"
            fade={false}
            layers={5}
            perspective="500px"
            // className = "W-class"
            style={{
              // lineHeight: "1vh",

              // fontSize: "20vh",
              color: "#FFC107",
              textShadow: `-1px -1px 1px #BF9105,
                 1px 1px 1px #BF9105`,
            }}
          >
            <span>W</span>
          </Ztext>
          <Ztext
            depth="1rem"
            direction="both"
            event="pointer"
            eventRotation="40deg"
            eventDirection="reverse"
            fade={false}
            layers={5}
            perspective="500px"
            style={{
              // lineHeight: "1vh",

              // fontSize: "20vh",
              color: "#8BC34A",
              textShadow: `-1px -1px 1px #689238, 
               1px 1px 1px #689238`,
            }}
          >
            <span>E</span>
          </Ztext>
          <Ztext
            depth="1rem"
            direction="both"
            event="pointer"
            eventRotation="40deg"
            eventDirection="default"
            fade={false}
            layers={5}
            perspective="500px"
            style={{
              // lineHeight: "1vh",

              // fontSize: "20vh",
              color: "#03A9F4",
              textShadow: `-1px -1px 1px #017EB7, 
               1px 1px 1px #017EB7`,
            }}
          >
            <span>L</span>
          </Ztext>
          <Ztext
            depth="2rem"
            direction="both"
            event="pointer"
            eventRotation="40deg"
            eventDirection="reverse"
            fade={false}
            layers={5}
            perspective="500px"
            style={{
              // lineHeight: "1vh",

              // fontSize: "20vh",
              color: "#F44336",
              textShadow: `-1px -1px 1px #f4433679, 
               1px 1px 1px #f4433679`,
            }}
          >
            <span>C</span>
          </Ztext>
          <Ztext
            depth="2rem"
            direction="both"
            event="pointer"
            eventRotation="40deg"
            eventDirection="default"
            fade={false}
            layers={5}
            perspective="500px"
            style={{
              // lineHeight: "1vh",

              // fontSize: "20vh",
              color: "#3F51B5",
              textShadow: `-1px -1px 1px #3f51b59c, 
               1px 1px 1px #3f51b59c`,
              // textShadow: `-1px -1px 1px #2F3D88,
              //    1px 1px 1px #2F3D88`,
            }}
          >
            <span>O</span>
          </Ztext>
          <Ztext
            depth="1rem"
            direction="both"
            event="pointer"
            eventRotation="40deg"
            eventDirection="default"
            fade={false}
            layers={5}
            perspective="500px"
            style={{
              // lineHeight: "1vh",

              // fontSize: "20vh",
              color: "#FFC107",
              textShadow: `-1px -1px 1px #BF9105, 
               1px 1px 1px #BF9105`,
            }}
          >
            <span>M</span>
          </Ztext>
          <Ztext
            depth="1rem"
            direction="both"
            event="pointer"
            eventRotation="40deg"
            eventDirection="reverse"
            fade={false}
            layers={5}
            perspective="500px"
            style={{
              // lineHeight: "1vh",

              // fontSize: "20vh",
              color: "#8BC34A",
              textShadow: `-1px -1px 1px #689238, 
               1px 1px 1px #689238`,
            }}
          >
            <span>E</span>
          </Ztext>
        </span>

        <br />
        <span className="welcome-banner-small">
          <Ztext
            depth="1rem"
            direction="both"
            event="pointer"
            eventRotation="40deg"
            eventDirection="reverse"
            fade={false}
            layers={5}
            perspective="500px"
            style={{
              // lineHeight: "8vh",
              // fontSize: "8vh",
              padding: "0px",
              margin: "0px",
              color: "#8BC34A",
              textShadow: `-1px -1px 1px #689238, 
               1px 1px 1px #689238`,
            }}
          >
            <span>T</span>
          </Ztext>
          <Ztext
            depth="1rem"
            direction="both"
            event="pointer"
            eventRotation="40deg"
            eventDirection="reverse"
            fade={false}
            layers={5}
            perspective="500px"
            style={{
              // lineHeight: "8vh",
              // fontSize: "8vh",
              padding: "0px",
              margin: "0px",
              color: "#8BC34A",
              textShadow: `-1px -1px 1px #689238, 
               1px 1px 1px #689238`,
            }}
          >
            <span>O</span>
          </Ztext>
        </span>
        <br />
        <span className="welcome-banner-medium">
          <Ztext
            depth="1rem"
            direction="both"
            event="pointer"
            eventRotation="40deg"
            eventDirection="default"
            fade={false}
            layers={5}
            perspective="500px"
            style={{
              // lineHeight: "1vh",

              // fontSize: "20vh",
              color: "#FFC107",
              textShadow: `-1px -1px 1px #BF9105, 
               1px 1px 1px #BF9105`,
            }}
          >
            <span>M</span>
          </Ztext>
          <Ztext
            depth="1rem"
            direction="both"
            event="pointer"
            eventRotation="40deg"
            eventDirection="reverse"
            fade={false}
            layers={5}
            perspective="500px"
            style={{
              // lineHeight: "1vh",

              // fontSize: "20vh",
              color: "#8BC34A",
              textShadow: `-1px -1px 1px #689238, 
               1px 1px 1px #689238`,
            }}
          >
            <span>Y</span>
          </Ztext>
          <span>&nbsp;</span>
          <Ztext
            depth="1rem"
            direction="both"
            event="pointer"
            eventRotation="40deg"
            eventDirection="default"
            fade={false}
            layers={5}
            perspective="500px"
            style={{
              // lineHeight: "1vh",

              // fontSize: "20vh",
              color: "#FFC107",
              textShadow: `-1px -1px 1px #BF9105, 
               1px 1px 1px #BF9105`,
            }}
          >
            <span>W</span>
          </Ztext>
          <Ztext
            depth="1rem"
            direction="both"
            event="pointer"
            eventRotation="40deg"
            eventDirection="reverse"
            fade={false}
            layers={5}
            perspective="500px"
            style={{
              // lineHeight: "1vh",

              // fontSize: "20vh",
              color: "#8BC34A",
              textShadow: `-1px -1px 1px #689238, 
               1px 1px 1px #689238`,
            }}
          >
            <span>O</span>
          </Ztext>
          <Ztext
            depth="1rem"
            direction="both"
            event="pointer"
            eventRotation="40deg"
            eventDirection="default"
            fade={false}
            layers={5}
            perspective="500px"
            style={{
              // lineHeight: "1vh",

              // fontSize: "20vh",
              color: "#03A9F4",
              textShadow: `-1px -1px 1px #017EB7, 
               1px 1px 1px #017EB7`,
            }}
          >
            <span>R</span>
          </Ztext>
          <Ztext
            depth="2rem"
            direction="both"
            event="pointer"
            eventRotation="40deg"
            eventDirection="reverse"
            fade={false}
            layers={5}
            perspective="500px"
            style={{
              // lineHeight: "1vh",

              // fontSize: "20vh",
              color: "#F44336",
              textShadow: `-1px -1px 1px #f4433679, 
               1px 1px 1px #f4433679`,
            }}
          >
            <span>L</span>
          </Ztext>
          <Ztext
            depth="1rem"
            direction="both"
            event="pointer"
            eventRotation="40deg"
            eventDirection="reverse"
            fade={false}
            layers={5}
            perspective="500px"
            style={{
              lineHeight: "15vh",
              fontSize: "20vh",
              padding: "0px",
              margin: "0px",
              color: "#8BC34A",
              textShadow: `-1px -1px 1px #689238, 
               1px 1px 1px #689238`,
            }}
          >
            <span>D</span>
          </Ztext>
        </span>
      </div>
    </>
  );
};
export default WelcomeBanner;
